import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'

import { PerformanceFacade } from '~/core/features'

export const performanceQuarterListResolver: ResolveFn<void> = () => {
  return inject(PerformanceFacade).getPerformanceQuarterList()
}
